import axios from "axios";

const API = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? "http://localhost:5000/api"
      : "/api",
  withCredentials: true,
});

API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");

  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }

  return req;
});

API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config || {};

    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      originalRequest.url &&
      !originalRequest.url.includes("/auth/refresh-token")
    ) {
      originalRequest._retry = true;

      try {
        const res = await API.post("/auth/refresh-token");

        const newToken = res.data.accessToken;

        localStorage.setItem("token", newToken);

        API.defaults.headers.common.Authorization =
          `Bearer ${newToken}`;

        originalRequest.headers = originalRequest.headers || {};
        originalRequest.headers.Authorization =
          `Bearer ${newToken}`;

        return API(originalRequest);

      } catch {
        localStorage.removeItem("token");
        localStorage.removeItem("civilink_user");
        localStorage.removeItem("role");

        window.location.replace("/login");

        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export default API;
